(function() {
    angular
        .module("wzModule")
        .config(wzRouter)

    wzRouter.$inject = [
        "$stateProvider",
        "$urlRouterProvider",
        "$locationProvider"
    ]

    function wzRouter(
        $stateProvider,
        $urlRouterProvider,
        $locationProvider
    ){

        $stateProvider
            .state("wz", {
                url: "/wz/:wz_id",
                templateUrl: "app/components/wz/wz.view.html",
                controller : "WzController"
            })



            .state("wz.configuration-qws", {
                url: "/configuration",
                views: {
                    "wz_tab": {
                        templateUrl: "app/components/wz/configuration-qws.view.html",
                        controller : "WzQWSConfigurationController"
                    }
                }
            })
            .state("wz.configuration-se", {
                url: "/configuration",
                views: {
                    "wz_tab": {
                        templateUrl: "app/components/wz/configuration-se.view.html",
                        controller : "WzSEConfigurationController"
                    }
                }
            })
            .state("wz.history", {
                url: "/history",
                views: {
                    "wz_tab": {
                        templateUrl: "app/components/wz/history/history.view.html",
                        controller : "WzHistoryController"
                    }
                }
            })

        $urlRouterProvider.otherwise("/")
        $locationProvider.html5Mode(true)

    }
})()
